import React, { useState } from "react";
import PropTypes from "prop-types";
import { Input, Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import location from "../../../assets/images/LOCATION.png";

import "../Finance.scss";

const BillingAddresModal = ({ show, onCloseClick }: any) => {
  return (
    <>
      <Modal isOpen={show} centered={true} className="Billing">
        <ModalBody className="modal_Body">
          <img
            data-testing-id="closeIcon"
            onClick={() => onCloseClick(false)}
            className="closeIconModal"
            src={CLoseImg}
            alt=""
          />
        </ModalBody>
        <div className="p-0">
          <div className="address">
            <img src={location} alt="" />
            <h5>Buyer Address</h5>
          </div>{" "}
          <div className="BORDER"></div>
          <div className="Street">
            <p>1234 Elm Street, Apt 567</p>
            <p>Los Angeles, CA 90001</p>
            <p>United States</p>
            <p>
              Phone No: <span>0312 4554566</span>
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};

BillingAddresModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.bool,
};

export default BillingAddresModal;
